import React from "react";
import "./MaterialSwitch.css";

type MaterialSwitchProps = {
  id: string;
  name: string; // Added name prop
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean; // Added disabled prop
};

const MaterialSwitch: React.FC<MaterialSwitchProps> = ({ id, name, checked, onChange, disabled }) => {
  return (
    <label className="material-switch">
      <input
        type="checkbox"
        id={id}
        name={name} // Pass name prop
        checked={checked}
        onChange={onChange}
        className="material-switch-input"
        disabled={disabled} // Add disabled attribute
      />
      <span className="material-switch-slider"></span>
    </label>
  );
};

export default MaterialSwitch;
